module.exports = __webpack_public_path__ + "static/media/44635449_2199900406751805_9176731874590982144_o-thumb.5a233844.jpg";